import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { FacilityDetailsProvider } from 'contexts/FacilityDetailsContext'
import { FacilityConfigProvider } from 'contexts/FacilityConfigContext'
import { ModuleConfigProvider } from 'contexts/ModuleConfigContext'
import { PermissionProvider } from 'contexts/PermissionContext'
import { AVP_SERVICE_BARRIER_MANAGEMENT } from 'constants/avp_permissions'

const HazardBarrierAssetEvaluation = lazy(
  () => import('pages/HazardBarrierEvaluation/HazardBarrierAssetEvaluation')
)
const HazardBarriersProjectEvaluation = lazy(
  () => import('pages/HazardBarrierEvaluation/HazardBarriersProjectEvaluation')
)
const HazardBarrierEvaluationEditor = lazy(
  () => import('pages/HazardBarrierEvaluation/hazardBarrierEvaluationEditor')
)
const BarrierConfigurationScore = lazy(
  () => import('pages/HazardBarrierConfigurations/BarrierConfigurationScore')
)
const GetAttachmentById = lazy(() => import('pages/GetAttachmentById'))
const HazardBarrierDetailedMap = lazy(
  () => import('pages/HazardBarrierEvaluation/HazardBarriersDetailedMap')
)
const VulnerabilityAnalysis = lazy(
  () => import('pages/HazardBarrierEvaluation/VulnerabilityAnalysis')
)
const QuestionConfigurationPage = lazy(
  () => import('pages/HazardBarrierConfigurations/QuestionConfiguration')
)
const LoadsheetSetupPage = lazy(() => import('pages/Loadsheet/LoadsheetSetup'))
const LoadsheetActionsFindings = lazy(() => import('pages/Loadsheet/LoadsheetActionsFindings'))
const PipelinesSurvivability = lazy(
  () => import('pages/HazardBarrierEvaluation/PipelinesSurvivability')
)

const BarrierRoutes = (
  <>
    <Route
      path="/hazard-barrier-evaluation/project/:project_id"
      element={
        <PermissionProvider serviceName={AVP_SERVICE_BARRIER_MANAGEMENT}>
          <FacilityDetailsProvider>
            <FacilityConfigProvider slug="project_feature_config">
              <ModuleConfigProvider slug="barrier_management_config">
                <HazardBarriersProjectEvaluation />
              </ModuleConfigProvider>
            </FacilityConfigProvider>
          </FacilityDetailsProvider>
        </PermissionProvider>
      }
    />
<Route
      path="/hazard-barrier-evaluation/project/:project_id/asset/:asset_id"
      element={
        <PermissionProvider serviceName={AVP_SERVICE_BARRIER_MANAGEMENT}>
          <FacilityDetailsProvider>
            <FacilityConfigProvider slug="project_feature_config">
              <ModuleConfigProvider slug="barrier_management_config">
                <HazardBarrierAssetEvaluation />
              </ModuleConfigProvider>
            </FacilityConfigProvider>
          </FacilityDetailsProvider>
        </PermissionProvider>
      }
    />

    <Route
      path="/hazard-barrier-configuration/project/:project_id/asset/:asset_id/scores"
      element={
        <PermissionProvider serviceName={AVP_SERVICE_BARRIER_MANAGEMENT}>
          <FacilityConfigProvider slug="project_feature_config">
            <FacilityDetailsProvider>
              <ModuleConfigProvider slug="barrier_management_config">
                <BarrierConfigurationScore />
              </ModuleConfigProvider>
            </FacilityDetailsProvider>
          </FacilityConfigProvider>
        </PermissionProvider>
      }
    />
    <Route
      path="/hazard-barrier-configuration/project/:project_id/asset/:asset_id/configuration"
      element={
        <PermissionProvider serviceName={AVP_SERVICE_BARRIER_MANAGEMENT}>
          <FacilityConfigProvider slug="project_feature_config">
            <FacilityDetailsProvider>
              <ModuleConfigProvider slug="barrier_management_config">
                <QuestionConfigurationPage />
              </ModuleConfigProvider>
            </FacilityDetailsProvider>
          </FacilityConfigProvider>
        </PermissionProvider>
      }
    />
    <Route path="/attachment/:id" element={<GetAttachmentById />} />

    <Route
      path="/hazard-barrier-evaluation/project/:project_id/map"
      element={
        <PermissionProvider serviceName={AVP_SERVICE_BARRIER_MANAGEMENT}>
          <FacilityConfigProvider slug="project_feature_config">
            <FacilityDetailsProvider>
              <ModuleConfigProvider slug="barrier_management_config">
                <HazardBarrierDetailedMap />
              </ModuleConfigProvider>
            </FacilityDetailsProvider>
          </FacilityConfigProvider>
        </PermissionProvider>
      }
    />
    <Route
      path="/hazard-barrier-evaluation/project/:project_id/asset/:asset_id/vulnerability-analysis"
      element={
        <PermissionProvider serviceName={AVP_SERVICE_BARRIER_MANAGEMENT}>
          <FacilityConfigProvider slug="project_feature_config">
            <FacilityDetailsProvider>
              <ModuleConfigProvider slug="barrier_management_config">
                <VulnerabilityAnalysis />
              </ModuleConfigProvider>
            </FacilityDetailsProvider>
          </FacilityConfigProvider>
        </PermissionProvider>
      }
    />
    <Route
      path="/hazard-barrier-evaluation/project/:project_id/asset/:asset_id/pipelines-survivability"
      element={
        <PermissionProvider serviceName={AVP_SERVICE_BARRIER_MANAGEMENT}>
          <FacilityConfigProvider slug="project_feature_config">
            <FacilityDetailsProvider>
              <ModuleConfigProvider slug="barrier_management_config">
                <PipelinesSurvivability />
              </ModuleConfigProvider>
            </FacilityDetailsProvider>
          </FacilityConfigProvider>
        </PermissionProvider>
      }
    />
    <Route
      path="/hazard-barrier-configuration/project/:project_id/asset/:asset_id/loadsheet-setup"
      element={
        <PermissionProvider serviceName={AVP_SERVICE_BARRIER_MANAGEMENT}>
          <FacilityConfigProvider slug="project_feature_config">
            <FacilityDetailsProvider>
              <ModuleConfigProvider slug="barrier_management_config">
                <LoadsheetSetupPage />
              </ModuleConfigProvider>
            </FacilityDetailsProvider>
          </FacilityConfigProvider>
        </PermissionProvider>
      }
    />
    <Route
      path="/hazard-barrier-configuration/project/:project_id/asset/:asset_id/loadsheet-actions-findings"
      element={
        <PermissionProvider serviceName={AVP_SERVICE_BARRIER_MANAGEMENT}>
          <FacilityConfigProvider slug="project_feature_config">
            <FacilityDetailsProvider>
              <ModuleConfigProvider slug="barrier_management_config">
                <LoadsheetActionsFindings />
              </ModuleConfigProvider>
            </FacilityDetailsProvider>
          </FacilityConfigProvider>
        </PermissionProvider>
      }
    />
  </>
)

export default BarrierRoutes
